import React from "react";
import api from './services/api';

export async function getVersion() {
    const response = (await api.get('versioninfo')).data;      
    return response
}